import React, {useEffect, useState} from 'react';

function ApplyNow() {
    let [step, changeStep] = useState(1)

    const nextStep = () => {
        changeStep(step + 1);
        console.log(step)
    }

    const prevStep = () => {
        changeStep(step - 1);
        console.log(step)
    };
    const url = 'https://restcountries.com/v3.1/all';
    const [data, setData] = useState([])
    const fetchInfo = () => {
        return fetch(url)
            .then((res) => res.json())
            .then((d) => setData(d))
    }

    useEffect(() => {
        fetchInfo();
    }, [])
    return (
        <>
            <section className="applyNowSec">
                <div className="container-md">
                    <div className="row">
                        <div className="col-lg-10">
                            <div className="head">
                                <h1>Now is the Time to Apply</h1>
                                <p>
                                    Ready to take the next step in your DevOps journey with Skill Bridge ? Our
                                    application form
                                    is your gateway to joining our programs and accessing top-tier DevOps education.
                                    Applying
                                    is simple and convenient, and we're here to assist you throughout the process.
                                </p>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="applyForm">
                                <h3>
                                    Skill Bridge Student Application form
                                </h3>
                                <div className="progress">
                                    <div className="bar">
                                        <span className={step >= 1 ? 'active' : ''}/>
                                        <span className={step >= 2 ? 'active' : ''}/>
                                        <span className={step >= 3 ? 'active' : ''}/>
                                        <span className={step >= 4 ? 'active' : ''}/>
                                        <span className={step >= 5 ? 'active' : ''}/>
                                        <span className={step >= 6 ? 'active' : ''}/>
                                        <span className={step >= 7 ? 'active' : ''}/>
                                        <span className={step >= 8 ? 'active' : ''}/>
                                        <span className={step >= 9 ? 'active' : ''}/>
                                        <span className={step >= 10 ? 'active' : ''}/>
                                        <span className={step >= 11 ? 'active' : ''}/>
                                        <span className={step >= 12 ? 'active' : ''}/>
                                        <span className={step >= 13 ? 'active' : ''}/>
                                    </div>
                                </div>
                                <form action="">

                                    <div className={step === 1 ? 'inputCont active' : 'inputCont'}>
                                        <label>1. First Name?<span>*</span></label>
                                        <input type="text" placeholder='Type your answer here...'/>
                                    </div>
                                    <div className={step === 2 ? 'inputCont active' : 'inputCont'}>
                                        <label>2. Surname?<span>*</span></label>
                                        <input type="text" placeholder='Type your answer here...'/>
                                    </div>
                                    <div className={step === 3 ? 'inputCont active' : 'inputCont'}>
                                        <label>3. Email Address?<span>*</span></label>
                                        {/*<span>We’ll send you an email with instructions to progress your application.</span>*/}
                                        <input type="email" placeholder='Type your answer here...'/>
                                    </div>
                                    <div className={step === 4 ? 'inputCont active' : 'inputCont'}>
                                        <label>4. Phone Number?<span>*</span></label>
                                        <input type="text" placeholder='Type your answer here...'/>
                                    </div>
                                    <div className={step === 5 ? 'inputCont active' : 'inputCont'}>
                                        <label>5. Gender?<span>*</span></label>
                                        <select name="" id="">
                                            <option defaultValue disabled selected>Select an Option</option>
                                            <option value="">Male</option>
                                            <option value="">Female</option>
                                            <option value="">Rather not to say</option>
                                        </select>
                                    </div>
                                    <div className={step === 6 ? 'inputCont active' : 'inputCont'}>
                                        <label>6. Ethnicity?<span>*</span></label>
                                        <input type="text" placeholder='Type your answer here...'/>
                                    </div>
                                    <div className={step === 7 ? 'inputCont active' : 'inputCont'}>
                                        <label>7. Which Skill Bridge courses are you interested
                                            in?<span>*</span></label>
                                        <select name="" id="">
                                            <option defaultValue disabled selected>Select an Option</option>
                                            <option value="">DevOps Engineer</option>
                                            <option value="">Solution Architect</option>
                                            <option value="">SysOps Administrator</option>
                                            <option value="">Accreditation</option>
                                            <option value="">Other</option>
                                        </select>
                                    </div>
                                    <div className={step === 8 ? 'inputCont active' : 'inputCont'}>
                                        <label>8. Preference of learning?<span>*</span></label>
                                        <select name="" id="">
                                            <option defaultValue disabled selected>Select an Option</option>
                                            <option value="">On-site</option>
                                            <option value="">Remote</option>
                                            <option value="">Blended Learning</option>
                                        </select>
                                    </div>
                                    <div className={step === 9 ? 'inputCont active' : 'inputCont'}>
                                        <label>9. Country of residency:<span>*</span></label>
                                        <select name="" id="">
                                            <option defaultValue disabled selected>Select an Option</option>
                                            {data.map((dataObj, index) => {
                                                return <option value=''>{dataObj.name.common}</option>
                                            })}
                                        </select>
                                    </div>
                                    <div className={step === 10 ? 'inputCont active' : 'inputCont'}>
                                        <label>10. Do you have the right to work in the UK?<span>*</span></label>
                                        <select name="" id="">
                                            <option defaultValue disabled selected>Select an Option</option>
                                            <option value="">Yes</option>
                                            <option value="">No</option>
                                        </select>
                                    </div>
                                    <div className={step === 11 ? 'inputCont active' : 'inputCont'}>
                                        <label>11. What is your level of programming experience?<span>*</span></label>
                                        <select name="" id="">
                                            <option defaultValue disabled selected>Select an Option</option>
                                            <option value="">Basic - Beginner</option>
                                            <option value="">Intermediate</option>
                                            <option value="">Advanced</option>
                                        </select>
                                    </div>
                                    <div className={step === 12 ? 'inputCont active' : 'inputCont'}>
                                        <label>12. When would you like to start?<span>*</span></label>
                                        <select name="" id="">
                                            <option defaultValue disabled selected>Select an Option</option>
                                            <option value="">January 2024</option>
                                            <option value="">May 2024</option>
                                            <option value="">September 2024</option>
                                        </select>
                                    </div>
                                    <div className={step === 13 ? 'inputCont active' : 'inputCont'}>
                                        <label>13. How did you first hear about Skill Bridge?<span>*</span></label>
                                        <select name="" id="">
                                            <option defaultValue disabled selected>Select an Option</option>
                                            <option value="">Skill Bridge Website</option>
                                            <option value="">Friends</option>
                                            <option value="">Family</option>
                                            <option value="">Colleagues</option>
                                            <option value="">Google</option>
                                            <option value="">Social Media</option>
                                            <option value="">Professional Recommendation</option>
                                            <option value="">Other</option>
                                        </select>
                                    </div>
                                    <div className="btnCont">
                                        {step < 13 && (
                                            <button onClick={() => nextStep()} type='button'
                                                    className="themeBtn">Submit</button>
                                        )}
                                        {step === 13 && (
                                            <button type='submit' className="themeBtn">Submit</button>
                                        )}
                                        {step > 1 && (
                                            <button onClick={() => prevStep()} className="backBtn"
                                                    type='button'>
                                                <i className="fas fa-long-arrow-alt-left"/>
                                                Back
                                            </button>
                                        )}
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default ApplyNow